<template>
    <div>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <v-container class="px-6" fluid>
            <div class="page-title">
                <h2>{{ $t("Feed Ingredients Threshold Settings") }}</h2>
                <v-spacer></v-spacer>

                <v-btn color="primary" dark @click="saveSetting">
                    {{ $t("save settings") }}
                </v-btn>
            </div>
            <v-card class="pa-6" min-height='73vh'>
                <v-row no-gutters direction="row">
                    <v-col cols="6">
                        Low Stock <span class="red--text">*</span>
                        <v-row no-gutters class="pt-1">
                            <v-col cols="9">
                                <v-text-field class="threshold-description" filled outlined :value="text.low" readonly
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field class="threshold-input" outlined dense v-model="thresholdSetting.lowStock"
                                    type="number" min="0" suffix="kg"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="6">
                        Critically Low Stock <span class="red--text">*</span>
                        <v-row no-gutters class="pt-1">
                            <v-col cols="9">
                                <v-text-field class="threshold-description" filled outlined :value="text.critical" readonly
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field class="threshold-input" outlined dense v-model="thresholdSetting.criticallyLowStock"
                                    type="number" min="0" suffix="kg"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="6">
                        Expires Soon Rations <span class="red--text">*</span>
                        <v-row no-gutters class="pt-1">
                            <v-col cols="9">
                                <v-text-field class="threshold-description" filled outlined :value="text.expire" readonly
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field class="threshold-input" outlined dense v-model="thresholdSetting.rationExpire"
                                    type="number" min="0" suffix="days"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
    </div>
</template>
  
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import { saveThresholdSetting } from "@/graphql/FeedMgmt.gql";
import { thresholdSetting } from "@/graphql/Feed.gql";
import FarmService from "@/_services/farmService";

export default {
    name: "ThresholdSettings",
    data() {
        return {
            loading: true,
            breadcrumbs: [
                {
                    text: this.$t("dashbaord"),
                    disabled: false,
                    to: "/",
                },
                {
                    text: this.$t("Feed Management"),
                    disabled: true,
                },
                {
                    text: this.$t("Feed Threshold Settings"),
                    disabled: true,
                },
            ],
            thresholdSetting: {
                lowStock: 0,
                criticallyLowStock: 0,
                rationExpire: 0
            },
            text: {
                low: "If Ingredient Inventory Stock is Equal To or Less Than",
                critical: "If Ingredient Inventory Stock is Equal To or Less Than",
                expire: "If Ingredient Expiry is Equal To or Less Than"
            }
        };
    },
    mixins: [loadingMixin],
    methods: {

        async getThresholdSetting(){
            this.startLoading();
            const { data } = await this.$apollo.query({
                query: thresholdSetting
            });
            this.thresholdSetting = data.thresholdSetting;
            this.stopLoading();
        },

        async saveSetting() {
            this.startLoading();
            await this.$apollo.mutate({
                mutation: saveThresholdSetting,
                variables: {
                    createThresholdSettingInput: {
                        lowStock: Number(this.thresholdSetting.lowStock),
                        criticallyLowStock: Number(this.thresholdSetting.criticallyLowStock),
                        rationExpire: Number(this.thresholdSetting.rationExpire)
                    }
                }
            })
                .then((res) => {
                    if (res.data.saveThresholdSetting?.success) {
                        this.$notify({
                            title: "Success!",
                            text: 'Successfully updated ration setting.',
                            type: "success",
                        });
                    }
                    this.stopLoading();
                })
                .catch((error) => {
                    this.$notify({
                        title: "Error!",
                        text: `Error saving ration setting, ${error}`,
                        type: "error",
                    });
                    this.stopLoading();
                });
        }
    },
    computed: {},
    async created() {
        const { data } = await FarmService.getPrimaryFarm();
        const role=this.$store.getters.getUser?.userDetail?.role;
        if(role !== 'admin'){
        this.$router.replace({ path: `/myfarm/detail/${(data && data.id )|| null}` });
        }
    },
    async mounted() {
        document.title = "Threshold Settings";
        this.getThresholdSetting();
    },
};
</script>
  
<style lang="scss" scoped>
.border {
    border: 2px solid;
    border-color: #dae1ec;
}

.threshold-description {
    color: black;
    border-radius: 4px 0px 0px 4px;
}

.threshold-input {
    border-radius: 0px 4px 4px 0px;
}
</style>
  